<template>
  <div class="flex flex-col gap-5">
    <!-- Main Image Container -->
    <div
      class="w-full bg-white border border-border rounded-lg p-8 flex items-center justify-center aspect-square overflow-hidden group relative"
    >
      <!-- Imagen Principal con Vue -->
      <template
        v-if="selectedProduct.images && selectedProduct.images.length > 0"
      >
        <img
          :src="
            selectedProduct.images[currentImageIndex]
              ? selectedProduct.images[currentImageIndex].image
              : selectedProduct.images[0].image
          "
          :alt="selectedProduct.name"
          fetchpriority="high"
          :style="vtStyle"
          class="w-full h-full object-contain mix-blend-multiply group-hover:scale-110 transition-transform duration-500 ease-in-out cursor-pointer"
        />
      </template>

      <!-- Fallback: No Image -->
      <template v-else>
        <img
          :src="noImagePath"
          alt="No image available"
          fetchpriority="high"
          class="w-full h-full object-contain mix-blend-multiply opacity-50"
        />
      </template>

      <!-- Zoom Button 
            <button class="absolute bottom-3 right-3 p-2 bg-white shadow-md rounded-full text-text-secondary hover:text-primary transition-colors border border-border z-10">
                <vue-icon.zoom_in class="text-xl" />
            </button>
            -->
    </div>

    <!-- Thumbnails & Actions Container -->
    <div class="flex flex-col gap-4">
      <!-- Thumbnails List -->
      <template
        v-if="selectedProduct.images && selectedProduct.images.length > 1"
      >
        <div class="flex gap-3 overflow-x-auto pb-1 scrollbar-hide">
          <button
            v-for="(image, index) in selectedProduct.images"
            :key="index"
            @click="currentImageIndex = index"
            class="w-20 aspect-square shrink-0 rounded-md p-1 bg-white overflow-hidden transition-all duration-200"
            :class="
              currentImageIndex === index
                ? 'border-2 border-primary ring-2 ring-primary/10 ring-offset-1'
                : 'border border-border hover:border-primary opacity-70 hover:opacity-100'
            "
          >
            <img
              :src="image.thumbnail || image.image"
              :alt="selectedProduct.name + ' view ' + (index + 1)"
              loading="lazy"
              class="w-full h-full object-contain mix-blend-multiply"
            />
          </button>
        </div>
        <!-- <div class="h-px bg-border w-full"></div> -->
      </template>

      <!-- Extra Actions (3D & Measures) 
            <div class="grid grid-cols-2 gap-3">
                <button class="flex items-center justify-center gap-2 py-2 px-3 rounded-lg border border-border hover:border-primary hover:bg-gray-50 bg-white transition-all group h-10">
                    <vue-icon.3d_rotation class="text-[20px] text-text-secondary group-hover:text-primary" />
                    <span class="text-sm font-medium text-text-secondary group-hover:text-primary">3D View</span>
                </button>
                <button class="flex items-center justify-center gap-2 py-2 px-3 rounded-lg border border-border hover:border-primary hover:bg-gray-50 bg-white transition-all group h-10">
                    <vue-icon.square_foot class="text-[20px] text-text-secondary group-hover:text-primary" />
                    <span class="text-sm font-medium text-text-secondary group-hover:text-primary">Measures</span>
                </button>
            </div>
            -->
    </div>
  </div>
</template>

<script>
export default {
  name: "DesktopImages",
  props: {
    selectedProduct: {
      type: Object,
      required: true,
    },
    noImagePath: {
      type: String,
      default: "/front/img/product_images/no-image.jpg",
    },
    // Nombre de la view transition compartido con la card del listado
    // (vt-<erp_reference>), generado en details.blade.php.
    transitionName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentImageIndex: 0,
    };
  },
  computed: {
    vtStyle() {
      if (!this.transitionName) return {};
      return {
        "view-transition-name": this.transitionName,
        "view-transition-class": "vt-product-image",
      };
    },
  },
  watch: {
    selectedProduct() {
      this.currentImageIndex = 0;
    },
  },
};
</script>
